module.exports = __webpack_public_path__ + "static/media/Comfortaa-Bold.c4a1f054.ttf";